module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-24FEBBRAIO-small-37c75d321232f048b753c606c5f31390.png";